import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const Chart = ({
  data,
  total,
  centerLabel = "Total",
  onFilterSelect,
  selectedFilter = "all",
}) => {
  const COLORS = ["#8F351C", "#E5E5E5", "#2e7d32", "#1976d2"];

  const percentage =
    total > 0
      ? ((data[0]?.value / total) * 100).toFixed(1)
      : 0;

  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      
      {/* DONUT CHART */}
      <div style={{ width: "100%", height: 250 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={data}
              innerRadius={70}
              outerRadius={100}
              paddingAngle={3}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell
                  key={index}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>

            {/* Center Text */}
            <text
              x="50%"
              y="45%"
              textAnchor="middle"
              dominantBaseline="middle"
              style={{ fontSize: "22px", fontWeight: 600 }}
            >
              {percentage}%
            </text>

            <text
              x="50%"
              y="58%"
              textAnchor="middle"
              dominantBaseline="middle"
              style={{ fontSize: "14px", fill: "#666" }}
            >
              {centerLabel}
            </text>
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* SUMMARY */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          marginTop: "10px",
          fontSize: "14px",
        }}
      >
        <button
          type="button"
          className={`chart-summary-item ${
            selectedFilter === "all" ? "active" : ""
          }`}
          onClick={() => onFilterSelect?.("all")}
          disabled={!onFilterSelect}
        >
          <div style={{ fontWeight: 600 }}>Total Tamu</div>
          <div>{total}</div>
        </button>

        {data.map((item, index) => (
          <button
            type="button"
            key={index}
            className={`chart-summary-item ${
              selectedFilter === item.filterKey ? "active" : ""
            }`}
            onClick={() => onFilterSelect?.(item.filterKey)}
            disabled={!onFilterSelect}
          >
            <div style={{ fontWeight: 600 }}>
              {item.name}
            </div>
            <div>{item.value}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Chart;
